import { render, staticRenderFns } from "./ProducerReportsProducts.vue?vue&type=template&id=573365aa&"
import script from "./ProducerReportsProducts.vue?vue&type=script&lang=js&"
export * from "./ProducerReportsProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports